export enum VideoEvent {
  VideoPlayed25 = 'video-played-25',
}

export interface VideoEventInterface {
  getName(): string;
}

export abstract class VideoEventAbstract implements VideoEventInterface {
  getName(): string {
    return this.constructor.name;
  }
}
